/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Earningspayoutfailed2Inputs */

const en_earningspayoutfailed2 = /** @type {(inputs: Earningspayoutfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Didn't go through, we'll try again`)
};

const de_earningspayoutfailed2 = /** @type {(inputs: Earningspayoutfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hat nicht geklappt, wir versuchen es erneut`)
};

/**
* | output |
* | --- |
* | "Didn't go through, we'll try again" |
*
* @param {Earningspayoutfailed2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const earningspayoutfailed2 = /** @type {((inputs?: Earningspayoutfailed2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earningspayoutfailed2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earningspayoutfailed2(inputs)
	return de_earningspayoutfailed2(inputs)
});
export { earningspayoutfailed2 as "earningsPayoutFailed" }